import { useState } from 'react';
import { useAuth } from './useAuth';
import { ChangePasswordModal } from './ChangePasswordModal';
import { passwordChangeRequired } from './passwordGate';

export function PasswordExpiredGate() {
  const { userDoc } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  // Captura "now" uma vez em mount — lazy initializer é puro para o compilador
  const [mountTime] = useState(() => Date.now());

  // Deriva direto do userDoc — sem useEffect
  if (!userDoc) return null;
  const needs = passwordChangeRequired(userDoc, mountTime) && !dismissed;

  return (
    <ChangePasswordModal
      open={needs}
      onClose={() => setDismissed(true)}
      blocking
    />
  );
}
